import { Link } from './../util/router';
import dashboard1Img from '../assets/landing/dashboard1.png';
import dashboard2Img from '../assets/landing/dashboard2.png';
import showrunnerLogo from '../assets/images/SHOWRUNNER.png';

function MacWindow({ src, alt, ratio = '16/9' }) {
  return (
    <div className="rounded-xl overflow-hidden shadow-2xl border border-gray-200 bg-white">
      
      <div className="flex items-center gap-1.5 px-3 py-2.5 bg-[#f0f0f0] border-b border-gray-200">
        <span className="h-3 w-3 rounded-full bg-[#FF5F57]" />
        <span className="h-3 w-3 rounded-full bg-[#FEBC2E]" />
        <span className="h-3 w-3 rounded-full bg-[#28C840]" />
      </div>
      
      <div className="overflow-hidden" style={{ aspectRatio: ratio }}>
        <img src={src} alt={alt} className="w-full h-full object-cover object-top" />
      </div>
    </div>
  );
}

function AdminLandingSection() {
  return (
    <section
      className="relative font-oswald overflow-x-hidden bg-[url(../assets/landing/bg-1.png)] bg-no-repeat bg-cover min-h-[calc(100vh-80px)] flex flex-col justify-center"
      id="admin-home"
    >
      <div className="w-full container mx-auto max-w-[1280px]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">

          <div className="text-sm py-8 px-10">
            <span className="inline-flex py-2 text-lg text-black font-medium items-center justify-center rounded-full">
              Admin Dashboard
            </span>

            <h1
              style={{ lineHeight: 1.2 }}
              className="md:text-4xl text-4xl text-dark tracking-wide font-bold mb-4 mt-6"
            >
              Manage your gallery&apos;s presence on{' '}
              <span className="text-dark-red">Showrunner</span>
            </h1>

            <p className="text-base font-medium text-muted leading-7 mt-5">
              Publish shows, track audience engagement, and manage your gallery profile —
              all in one place, reaching art-goers across New York and Los Angeles.
            </p>

            <div className="max-w-md mx-auto md:mx-0 md:mr-auto text-center mt-12">
              <Link to="/admin/apply">
                <div className="flex items-center justify-center gap-4 p-4 px-6 rounded-full bg-white shadow-2xl">
                  <h2 className="text-md md:text-lg font-semibold text-dark-red text-center">
                    Request access
                  </h2>
                </div>
              </Link>

              <p className="mt-5 text-sm text-muted">
                Already have access?{' '}
                <Link to="/admin/login" className="text-dark-red underline">
                  Sign in
                </Link>
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center py-8">
            <div className="relative flex-shrink-0" style={{ width: '500px', height: '660px' }}>
              
              <div className="absolute top-[290px] right-0 w-[440px] z-0">
                <MacWindow src={dashboard2Img} alt="Data board" />
              </div>
              
              <div className="absolute top-[30px] left-0 w-[440px] z-10">
                <MacWindow src={dashboard1Img} alt="Manage shows" ratio="16/10" />
              </div>
              
              <div className="absolute top-[10px] right-0 z-20">
                <div className="flex items-center gap-2 p-2 pe-6 rounded-full bg-white shadow-2xl">
                  <div className="rounded-full h-9 w-9 flex items-center justify-center">
                    <img src={showrunnerLogo} className="h-8 w-8" alt="Showrunner" />
                  </div>
                  <div className="mr-2">
                    <h6 className="text-sm font-medium text-default-900 whitespace-nowrap">Manage your venues and shows</h6>
                  </div>
                </div>
              </div>
              
              <div className="absolute top-[540px] left-0 z-20">
                <div className="flex items-center gap-2 p-2 pe-6 rounded-full bg-white shadow-2xl">
                  <div className="rounded-full h-9 w-9 flex items-center justify-center">
                    <img src={showrunnerLogo} className="h-8 w-8" alt="Showrunner" />
                  </div>
                  <div className="mr-2">
                    <h6 className="text-sm font-medium text-default-900 whitespace-nowrap">View audience engagement and reach</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default AdminLandingSection;
